import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { LogControllerDtoGemSocketUpdateLogListRequest, PerplayLogApi } from '../../models/src';
import { GEM_SOCKET_UPDATE_LOG_LIST_REQUEST } from '../../constants/log/gemSocketUpdateLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoGemSocketUpdateLogListResponse
  from '../../models/src/model/LogControllerDtoGemSocketUpdateLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* gemSocketUpdateLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoGemSocketUpdateLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogGemSocketUpdateLogListPost({ logControllerDtoGemSocketUpdateLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoGemSocketUpdateLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* gemSocketUpdateLogRootSaga() {
  yield all([
    takeEvery(GEM_SOCKET_UPDATE_LOG_LIST_REQUEST, gemSocketUpdateLogListRequestSaga),
  ]);
}

const gemSocketUpdateLogSaga = [
  fork(gemSocketUpdateLogRootSaga),
]

export default gemSocketUpdateLogSaga;
